module.exports = "html{line-height:1.15!important;-webkit-text-size-adjust:100%!important}body{margin:0!important}";